import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { motion } from "framer-motion";

const Logo = ({ alt, logo, link }) => {
  const item = {
    hidden: { opacity: 0, y: 10, transition:{duration: .3} },
    show: { opacity: 1, y: 0, transition:{duration: .3} },
  };
  return (
    <motion.div variants={item} className="relative z-20 flex-1 ">
      <a key={alt} href={link} className="block" target="#blank" rel="noref noopener">
        <GatsbyImage image={logo} className="" />
      </a>
    </motion.div>
  );
};

export default function PressLogos({ slice }) {
  const container = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: {
        delay: 1.8,
        staggerChildren: 0.2,
        when:"beforeChildren"
      },
    },
  };

  
  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="relative z-20 px-4 md:px-0 rounded-lg mb-4 md:mb-10 flex items-center md:max-w-2xl  md:w-full md:mx-auto space-x-4 sm:space-x-6 md:space-x-8"
    >
      {slice.items.map(({ logo_press, alt, link }, index) => (
        <Logo
          logo={logo_press.gatsbyImageData}
          alt={alt}
          link={link.url}
          key={index}
        />
      ))}
    </motion.div>
  );
}
